module.exports = __webpack_public_path__ + "static/media/Thwin-Su-Htwe.59184555.png";